module.exports = __webpack_public_path__ + "static/media/icon_approved_companies.62f5eacf.png";